import React from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
 
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  );
}
 
export function Dropdown() {
  const [open, setOpen] = React.useState(0);
 
  const handleOpen = (value) => setOpen(open === value ? 0 : value);
 
  return (
    <>
      <Accordion open={open === 1} icon={<Icon id={1} open={open} />}>
        <AccordionHeader className="bg-[#dcae96]  p-4 rounded-md shadow-md" onClick={() => handleOpen(1)}>What is Thrive?</AccordionHeader>
        <AccordionBody className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">  
        Thrive is a platform that connects individuals seeking mental health support with licensed and certified therapists.
        </AccordionBody>
      </Accordion><br/>
      <Accordion open={open === 2} icon={<Icon id={2} open={open} />}>
        <AccordionHeader className="bg-[#dcae96]  p-4 rounded-md shadow-mdcd" onClick={() => handleOpen(2)}>
        How Does Thrive Work?
        </AccordionHeader>
        <AccordionBody className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">
        Users can sign up for an account on our website or mobile app and browse through our list of therapists to find one that meets your needs. 
        Your can then book a session with the therapist.
        </AccordionBody>
      </Accordion><br />
      <Accordion open={open === 3} icon={<Icon id={3} open={open} />}>
        <AccordionHeader className="bg-[#dcae96]  p-4 rounded-md shadow-md" onClick={() => handleOpen(3)}>
        Are There Qualified Therapist?
        </AccordionHeader>
        <AccordionBody className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">
        Yes, all therapists on thrive are licensed and certified mental health professionals.
        </AccordionBody >
      </Accordion><br/>
      <Accordion open={open === 4} icon={<Icon id={4} open={open} />}>
        <AccordionHeader className="bg-[#dcae96]  p-4 rounded-md shadow-md" onClick={() => handleOpen(4)}>
        Is My Information Confidential?
        </AccordionHeader>
        <AccordionBody className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">
        Yes, we take privacy and confidentiality very seriously. 
        All sessions are encrypted and your information is protected.
        </AccordionBody>
      </Accordion><br/>
      <Accordion open={open ===5 } icon={<Icon id={5} open={open} />}>
        <AccordionHeader className="bg-[#dcae96]  p-4 rounded-md shadow-md" onClick={() => handleOpen(5)}>
        How Long Does A session Last?
        </AccordionHeader>
        <AccordionBody className="bg-[#D9D9D9] px-4  pt-4 pb-6 rounded-md">
        The duration of a standard session is fifty minutes to an hour.
        </AccordionBody>
      </Accordion>
    </>
  );
}